<template>
    <div style="height: 100%;overflow: auto;">
        <van-sticky>
            <div style="background-color: white;">
            <el-form :inline="true" class="demo-form-inline" size="mini" style="margin-top: 5px;background-color: #fff;text-align: center;">
              <el-form-item>
                <el-radio-group v-model="active" @change="activeChange">
                  <el-radio-button label="home">本月</el-radio-button>
                  <el-radio-button label="home1">上月</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </van-sticky>
        
        <el-descriptions class="margin-top" :column="2" border>
            <el-descriptions-item label="姓名">{{examineData.staffname}}</el-descriptions-item>
            <el-descriptions-item label="成交人数">{{examineData.number}}</el-descriptions-item>
            <el-descriptions-item label="成交金额">{{examineData.perf}}</el-descriptions-item>
            <el-descriptions-item label="新客人数">{{examineData.newnumber}}</el-descriptions-item>
            <el-descriptions-item label="新客金额">{{examineData.newamount}}</el-descriptions-item>
            <el-descriptions-item label="负责人数">{{examineData.bigdd}}</el-descriptions-item>
            <el-descriptions-item label="到店人数">{{examineData.bigcount}}({{$percentgae(examineData.bigcount/examineData.bigdd)}})</el-descriptions-item>
        </el-descriptions>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                examineData:{},
                brands:[],
                active:"home",
                storeid:localStorage.getItem("parentstoreid"),
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
                staffid:localStorage.getItem("staffid"),
            }
        },
        created() {
            this.getBeautyExamine();
        },
        methods:{
            activeChange(name){
                //console.log(name);
                if(name=="home"){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(name=="home1"){
                    let dates=this.$lastMonth();
                    this.fromdate=dates[0];
                    this.todate=dates[1];
                }
                this.getBeautyExamine();
            },
            getBeautyExamine(){
                this.$post("beautymanager/getBeautyStaffExamine",{storeid:this.storeid,staffid:this.staffid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        //this.examineData=res.object;
                        if(res.object!=null && res.object.length>0){
                            for(let val of res.object){
                                if(val.staffid==this.staffid){
                                    this.examineData=val;
                                    break;
                                }
                            }
                        }
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautystaffexaminedetal.vue